import React from 'react';
import { CTASection } from '../components/CTASection';
export function About() {
  return <div className="pt-12 pb-20" data-id="element-301">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16" data-id="element-302">
        <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-303">
          About Wear Haus Designs
        </h1>
        <p className="text-xl text-gray-600" data-id="element-304">
          Serving our community with quality custom apparel since 1980.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-305">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-306">
          <div data-id="element-307">
            <img src="https://cdn.magicpatterns.com/uploads/qisyBnMpm1xQ1fgCuHKLVE/308069355_784940316164973_820009927175267454_n.jpg" alt="Our Shop" className="rounded-2xl shadow-xl w-full" data-id="element-308" />
          </div>
          <div className="prose prose-lg text-gray-600" data-id="element-309">
            <p className="mb-4" data-id="element-310">
              Wear Haus Designs is a family-owned business located in LaGrange,
              Indiana. For over four decades, we have been providing
              high-quality screen printing, embroidery, and promotional products
              to businesses, schools, and organizations.
            </p>
            <p data-id="element-311">
              We pride ourselves on our attention to detail, customer service,
              and ability to handle orders of all sizes. From concept to
              completion, our team works closely with you to ensure your vision
              comes to life exactly as you imagined.
            </p>
          </div>
        </div>
      </div>

      <CTASection data-id="element-312" />
    </div>;
}